import React from 'react';
import PropTypes from 'prop-types';
import unescape from 'lodash.unescape';
import { loginEventEmitter } from 'components/Login';
import CommentWriteBox from './CommentWriteBox';
import Tooltip from './Tooltip';
import { bindGa } from '../../../../../helpers/analytics';
import { TOI_LIVE_DOMAIN } from '../../../../../constants';
import { RATE_TYPE } from '../../../../../modules/WithComments/config';
import { saveRatingValidation } from '../../../../../modules/WithComments/utils';
import { convertHtmlToStringText } from '../../../../../utils/common';

function getFlatChild(data) {
  if (!data || data.length === 0) {
    return [];
  }

  const children = [...data];
  const newChildArr = [];
  for (let i = 0; i < data.length; i += 1) {
    if (data[i].CHILD && data[i].CHILD.length > 0) {
      newChildArr.splice(
        newChildArr.length,
        0,
        children[i],
        ...getFlatChild(data[i].CHILD),
      );
    } else {
      newChildArr.splice(newChildArr.length, 0, children[i]);
    }
  }

  return newChildArr;
}
class CommmentItem extends React.Component {
  static propTypes = {
    userData: PropTypes.shape({
      getId: PropTypes.func,
    }),
    isUserLoggedin: PropTypes.func.isRequired,
    handleAddComment: PropTypes.func.isRequired,
    putVote: PropTypes.func.isRequired,
    onFlagComment: PropTypes.func.isRequired,
    // isValidRating: PropTypes.func.isRequired,
    data: PropTypes.shape({
      A_ID: PropTypes.number,
      F_NAME: PropTypes.string,
      A_D_N: PropTypes.string,
      CITY: PropTypes.string,
      C_D: PropTypes.string,
      C_A_ID: PropTypes.number,
      addedNow: PropTypes.number,
      C_T: PropTypes.string,
      CHILD: PropTypes.arrayOf(PropTypes.shape({})),
      AC_A_C: PropTypes.number,
      AC_D_C: PropTypes.number,
      user_reward: PropTypes.shape({}),
      user_reward_point_info: PropTypes.shape({}),
      _id: PropTypes.number,
    }).isRequired,
    pageMsid: PropTypes.string.isRequired,
    openLoginBox: PropTypes.func.isRequired,
    renderCommentList: PropTypes.func.isRequired,
    renderUserIcon: PropTypes.func.isRequired,
    parent: PropTypes.shape({}),
    parentUserName: PropTypes.string,
    isParent: PropTypes.bool,
    disclaimer: PropTypes.func.isRequired,
    styles: PropTypes.shape({}).isRequired,
    isPrime: PropTypes.bool,
    isWapView: PropTypes.bool,
    openCommentBox: PropTypes.bool,
    resetCommentBoxId: PropTypes.func,
    errorMsg: PropTypes.string,
    onFlagClick: PropTypes.func.isRequired,
    shouldShowFlagForm: PropTypes.bool,
    hideFlag: PropTypes.func.isRequired,
    commentTextInputRef: PropTypes.shape({}).isRequired,
    showVerificationMsg: PropTypes.bool,
    seoData: PropTypes.shape({}),
    isHighlighted: PropTypes.bool,
    level: PropTypes.number,
    isFollowee: PropTypes.bool,
    isPrivateUser: PropTypes.bool,
  };
  static defaultProps = {
    userData: undefined,
    parent: undefined,
    parentUserName: '',
    isParent: true,
    isPrime: false,
    isWapView: false,
    openCommentBox: false,
    resetCommentBoxId: () => {},
    errorMsg: '',
    shouldShowFlagForm: false,
    showVerificationMsg: false,
    seoData: {},
    isHighlighted: false,
    level: 0,
    isFollowee: false,
    isPrivateUser: true,
  };
  constructor() {
    super();
    this.state = {
      shouldShowResponses: false,
      shouldShowAddCommentBox: false,
      flagRequestComplete: false,
      // shouldShowFlagForm: false,
      shouldShowFlagReasonBox: false,
      showFlagErrorForNoSelection: false,
      showMoreComment: false,
      othersTextAreaVal: '',
      showAllReplies: false,
    };

    this.domRefs = {};
    this.flagReason = '';
    this.onVoteUp = this.onVoteUp.bind(this);
    this.onVoteDown = this.onVoteDown.bind(this);
    this.showAddCommentBox = this.showAddCommentBox.bind(this);
    this.toggleResponses = this.toggleResponses.bind(this);
    this.handleShowHideResponse = this.handleShowHideResponse.bind(this);
  }

  textAreaHandler = e => {
    this.setState({ othersTextAreaVal: e.target.value });
  };

  onFlagRequestComplete = () => {
    saveRatingValidation(this.msid, '103', 0, 1, RATE_TYPE.OFFENSIVE);
    this.setState({
      flagRequestComplete: true,
    });
  };

  onFlagSubmit = () => {
    const callback = data => {
      if (data && data.uid) {
        this.onFlagComment();
      }
    };
    if (!this.props.isUserLoggedin(this.props.userData)) {
      loginEventEmitter(callback);
    } else {
      this.onFlagComment();
    }
  };

  onFlagComment = () => {
    if (!this.props.isUserLoggedin(this.props.userData)) {
      return;
    }
    const { userData, data } = this.props;
    if (
      !this.flagReason ||
      !this.flagReason.trim() ||
      (this.flagReason.toLowerCase() === 'others' &&
        !this.state.othersTextAreaVal.trim())
    ) {
      this.setState({
        showFlagErrorForNoSelection: true,
      });
      return;
    }

    const isUserLoggedin = this.props.isUserLoggedin(this.props.userData)
      ? '1'
      : '0';
    const params = {
      ofreason: this.flagReason,
      ofusername: `${userData.getFirstName()} ${
        typeof userData.getLastName === 'function' && userData.getLastName()
          ? userData.getLastName()
          : ''
      }`,
      ofcommenteroid: data._id,
      ofcommentid: this.props.pageMsid,
      ofuserisloggedin: isUserLoggedin,
      ofuserssoid: userData.getEmail(),
      ofuseremail: userData.getEmail(),
    };

    this.props.hideFlag(this.props.data._id);
    this.props.onFlagComment(params, this.onFlagRequestComplete);
  };

  hideFlag = () => {
    this.props.hideFlag(this.props.data._id);
  };

  @bindGa({})
  onVoteUp() {
    this.props.putVote(this.props.data, true);
  }

  @bindGa({})
  onVoteDown() {
    this.props.putVote(this.props.data);
  }

  @bindGa({})
  showAddCommentBox(status) {
    const shouldShow = typeof status === 'boolean' ? status : true;
    this.setState({
      shouldShowAddCommentBox: shouldShow,
    });

    if (!status) {
      this.props.resetCommentBoxId();
    }
  }

  toggleResponses(shouldShow) {
    const shouldShowVar =
      typeof shouldShow === 'boolean'
        ? shouldShow
        : !this.state.shouldShowResponses;
    this.setState({
      shouldShowResponses: shouldShowVar,
      showAllReplies: false,
    });
  }

  @bindGa({})
  handleShowHideResponse() {
    this.toggleResponses();
  }

  getParentComment = (commentItem = this) => {
    let parentComment;
    if (commentItem.getParentComment) {
      parentComment = commentItem.getParentComment(this.props.parent);
    } else {
      parentComment = this;
    }
    return parentComment;
  };

  getImmediateParent = () => this.props.parent;

  getMsid = () => this.props.data._id;

  static pointsNeeded(user_points = 0) {
    let points_needed = '';

    if (parseInt(user_points, 10) === 0 || user_points < 250) {
      points_needed = 250 - user_points;
    } else if (user_points > 249 && user_points < 5000) {
      points_needed = 5000 - user_points;
    } else if (user_points > 4999 && user_points < 25000) {
      points_needed = 25000 - user_points;
    } else if (user_points > 24999 && user_points < 250000) {
      points_needed = 250000 - user_points;
    }
    return points_needed;
  }

  renderNextLevelOverlay = (user_points = 0) => {
    const pointsNeeded = CommmentItem.pointsNeeded(user_points);
    const s = this.props.styles;
    return (
      <React.Fragment>
        <p>
          <strong>{pointsNeeded}</strong> more points needed to reach next
          level.
        </p>
        <a
          href={`${TOI_LIVE_DOMAIN}/abouttimesrewards.cms`}
          className={s.more}
          target="_blank"
          rel="noopener noreferrer"
        >
          Know more about Times Points
        </a>
      </React.Fragment>
    );
  };

  renderBadges = data => {
    if (!data) {
      return null;
    }

    const badges = data.activityBadge || {};
    const s = this.props.styles;

    return (
      <div>
        <div className={s['heading-block']}>
          <h4>Badges Earned</h4>
        </div>
        <div className={`${s.content} ${s.clearfix}`}>
          {badges.map((item, i) => (
            <div className={s.section} key={i}>
              <img className={s.badge} src={item.currentBadge.bimg} alt="" />
              <p>{item.currentBadge.bname}</p>
              <div className={s.badgepoint}>{item.currentBadge.level}</div>
            </div>
          ))}
          <p className={s['more-info']}>
            <a
              href={`${TOI_LIVE_DOMAIN}/abouttimesrewards.cms`}
              className={s.more}
              target="_blank"
              rel="noopener noreferrer"
            >
              Know more about Times Points
            </a>
          </p>
        </div>
      </div>
    );
  };

  renderFlagForm = () => {
    const s = this.props.styles;
    return (
      <div>
        <div className={s['heading-block']}>
          <h4>Find this comment offensive?</h4>
        </div>
        <div className={`${s.content} ${s.clearfix}`}>
          <span className={s['success-message']}>
            Your reason has been submitted to the Admin.
          </span>
          <span className={s['info-txt']}>
            Choose your reason below and click on the Submit button. This will
            alert our moderators to take action
          </span>
          <h6>Reason for reporting:</h6>
          <ul
            className={s.reasons}
            onChange={event => this.onReasonChange(event)}
          >
            <li>
              <label>
                <input type="radio" name="radio1" value="Foul language" />
                <span>Foul language</span>
              </label>
            </li>
            <li>
              <label>
                <input type="radio" name="radio1" value="Defamatory" />
                <span>Defamatory</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="radio"
                  name="radio1"
                  value="Inciting hatred against a certain community"
                />
                <span>Inciting hatred against a certain community</span>
              </label>
            </li>
            <li>
              <label>
                <input type="radio" name="radio1" value="Out of context/Spam" />
                <span>Out of context/Spam</span>
              </label>
            </li>
            <li>
              <label>
                <input type="radio" name="radio1" value="Others" />
                <span>Others</span>
              </label>
            </li>
            {this.state.shouldShowFlagReasonBox && (
              <li>
                <textarea
                  ref={item => {
                    this.domRefs.reasonTextArea =
                      item || this.domRefs.reasonTextArea;
                  }}
                  className={s.offensive_popup_reason}
                  value={this.state.othersTextAreaVal}
                  onChange={e => this.textAreaHandler(e)}
                />
              </li>
            )}
          </ul>
          {this.state.showFlagErrorForNoSelection && (
            <div className={s.error}>Please enter a reason</div>
          )}
          <div className={s.buttons}>
            <span
              className={`${s.button} ${s.submit}`}
              onClick={this.onFlagSubmit}
            >
              Report this !
            </span>
            <span
              className={`${s.button} ${s.close_popup}`}
              onClick={this.hideFlag}
            >
              Close
            </span>
          </div>
        </div>
      </div>
    );
  };

  onReasonChange = event => {
    this.flagReason =
      event && event.target.value ? event.target.value.toLowerCase() : '';
    if (this.flagReason && this.flagReason.trim()) {
      this.setState({
        showFlagErrorForNoSelection: false,
      });
    }
    this.showFlagReasonBox(event);
  };

  showFlagReasonBox = event => {
    let shouldShow = false;
    const reason =
      event && event.target.value ? event.target.value.toLowerCase() : '';
    if (event.target === this.domRefs.reasonTextArea) {
      return;
    }
    if (reason === 'others') {
      shouldShow = true;
    }

    this.setState({
      shouldShowFlagReasonBox: shouldShow,
    });
  };

  onFlagClick = () => {
    this.props.onFlagClick(this.props.data);
  };

  handleAddComment = (commentData, user) => {
    this.props.handleAddComment(commentData, user);
    this.toggleResponses(true);
  };

  handleShowMoreComment = () => {
    this.setState({ showMoreComment: true });
  };

  showAllResponses = () => {
    this.setState({ showAllReplies: true });
  };

  render() {
    const {
      F_NAME,
      A_D_N,
      CITY,
      C_D,
      C_A_ID,
      addedNow,
      C_T,
      CHILD,
      AC_A_C,
      AC_D_C,
      // user_reward,
      // user_reward_point_info,
    } = this.props.data;
    const s = this.props.styles;
    const { data, shouldShowFlagForm } = this.props;
    const userThumb =
      data.user_detail && data.user_detail.thumb ? data.user_detail.thumb : '';
    const activePrimeUserPrcArr = [1, 3, 4, 5, 8];
    const primeUser = !!(
      data.user_detail &&
      data.user_detail.U_P_S &&
      activePrimeUserPrcArr.indexOf(parseInt(data.user_detail.U_P_S, 10)) !== -1
    );

    const {
      shouldShowResponses,
      shouldShowAddCommentBox,
      flagRequestComplete,
      // shouldShowFlagForm,
    } = this.state;

    // const rewardLevel =
    //   user_reward && user_reward.levelName
    //     ? user_reward.levelName.toLowerCase()
    //     : '';
    const { parentUserName, isParent } = this.props;
    const commentVal = unescape(C_T);
    const userCity =
      data.user_detail && data.user_detail.CITY ? data.user_detail.CITY : CITY;
    const userFullName = A_D_N || F_NAME;
    const userid =
      data.user_detail && data.user_detail._id ? data.user_detail._id : null;
    const isAuthor = C_A_ID;
    const isUserLoggedin = this.props.isUserLoggedin(this.props.userData)
      ? '1'
      : '0';
    const followerCount = parseInt(
      data.user_detail && data.user_detail.F_C ? data.user_detail.F_C : 0,
      10,
    );
    let followerText = '';
    if (followerCount > 0) {
      followerText = `( ${followerCount} ${
        followerCount > 1 ? 'followers' : 'follower'
      } )`;
    }
    const flatChild = getFlatChild(CHILD);
    const loggedInUserId =
      this.props.userData && typeof this.props.userData.getId === 'function'
        ? this.props.userData.getId()
        : '';
    return (
      <li
        className={`${s.comments_list} ${isAuthor ? s.aucmt : ''} ${
          !this.props.isPrime && this.props.isHighlighted ? s.highlighted : ''
        } ${primeUser ? s.primeuser : ''}`}
      >
        <div className={s.header}>
          {this.props.renderUserIcon(
            userThumb,
            `comment-profile_photo-comment_section|userid_${userid}`,
          )}
          <h3
            data-ga={`comment-profile_name-comment_section|userid_${userid}`}
            className={s.cmtname}
          >
            {convertHtmlToStringText(userFullName || '')}
          </h3>
          {/* {!isPrivateUser && (
            <div className={s.point_container}>
              {user_reward &&
                user_reward.statusPoints > 0 && (
                  <div className={s.tooltip_wrap}>
                    <span className={s[rewardLevel]}>
                      {user_reward.statusPoints}
                    </span>
                    <Tooltip
                      data={this.renderNextLevelOverlay(
                        user_reward.statusPoints,
                      )}
                      styles={s}
                    />
                  </div>
                )}
              {user_reward_point_info &&
                user_reward_point_info.activityBadge &&
                user_reward_point_info.activityBadge.length > 3 && (
                  <div className={s.badges}>
                    <Tooltip
                      data={this.renderBadges(user_reward_point_info)}
                      styles={s}
                    />
                  </div>
                )}
            </div>
          )} */}
        </div>
        {!this.props.isPrime && (
          <div className={s.user_details}>
            {parentUserName && (
              <span className={s.metadata}>
                <i className={s.iconreply} />
                {convertHtmlToStringText(parentUserName)}
              </span>
            )}
            {userCity &&
              userCity.toLowerCase() !== 'unknown' && (
                <span
                  className={s.userLocation}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: userCity,
                  }}
                />
              )}
            {!addedNow && C_D && <span className={s.postTime}>{C_D}</span>}
            {addedNow && <span className={s.postTime}>Just Now</span>}
            {F_NAME &&
              !this.props.isFollowee &&
              isUserLoggedin === '1' &&
              data.user_detail &&
              data.user_detail._id &&
              loggedInUserId !== data.user_detail._id && (
                <span
                  className={s.follow}
                  title={`Follow ${F_NAME} ${followerText}`}
                >
                  Follow
                </span>
              )}
            {this.props.isFollowee && (
              <span className={s.userfollowing}>
                <span
                  className={s.following}
                  title={`Following ${F_NAME} ${followerText}`}
                >
                  <i className={s.iconfollow} />
                  Following
                </span>
              </span>
            )}
          </div>
        )}
        {commentVal.length > 500 &&
          !this.state.showMoreComment && (
            <div className={s.comment_text}>
              <div
                className={s.truncated}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: `${commentVal.substr(0, 500)} ... `,
                }}
              />
              <span
                className={s.readmorecomment}
                onClick={() => this.handleShowMoreComment()}
              >
                Read More
              </span>
            </div>
          )}

        {(commentVal.length <= 500 ||
          (commentVal.length > 500 && this.state.showMoreComment)) && (
          <div
            className={s.comment_text}
            dangerouslySetInnerHTML={{
              __html: commentVal,
            }}
          />
        )}

        {!addedNow && (
          <div className={s.comment_actions}>
            <span
              onClick={e => this.showAddCommentBox(e)}
              data-ga={`comment-reply-comment_section|msid_${
                this.props.pageMsid
              }`}
              className={s.comment_reply}
            >
              Reply
            </span>
            {isParent &&
              CHILD &&
              !shouldShowResponses && (
                <a
                  data-ga={`comment-show_responses-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.handleShowHideResponse}
                  className={s.comment_response}
                >
                  Show responses
                </a>
              )}

            {isParent &&
              CHILD &&
              shouldShowResponses && (
                <a
                  data-ga={`comment-hide_responses-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.handleShowHideResponse}
                >
                  Hide responses
                </a>
              )}
            {this.props.toipLayout ? (
              <>
                <span
                  className={s.upContainer}
                  data-ga={`comment-upvote-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.onVoteUp}
                >
                  <span>{AC_A_C}</span>
                  <i className={s.voteUp} />
                </span>
                <span
                  className={s.downContainer}
                  data-ga={`comment-downvote-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.onVoteDown}
                >
                  <span>{AC_D_C}</span>
                  <i className={s.voteDown} />
                </span>
              </>
            ) : (
              <>
                <span
                  className={s.upContainer}
                  data-ga={`comment-upvote-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.onVoteUp}
                >
                  <i className={s.voteUp} />
                  <span>{AC_A_C}</span>
                </span>
                <span
                  className={s.downContainer}
                  data-ga={`comment-downvote-comment_section|commentid_${this.getMsid()}`}
                  onClick={this.onVoteDown}
                >
                  <i className={s.voteDown} />
                  <span>{AC_D_C}</span>
                </span>
              </>
            )}
            {flagRequestComplete && (
              <span className={s.flagComment}>
                {!this.props.isPrime ? 'flagged' : ''}
              </span>
            )}
            {!flagRequestComplete && (
              <span className={s.flagComment}>
                <span onClick={this.onFlagClick} className={s.flagicon}>
                  {!this.props.isPrime ? 'flag' : ''}
                </span>
                {shouldShowFlagForm && (
                  <Tooltip
                    data={this.renderFlagForm()}
                    styles={s}
                    offSetFromTop={60}
                  />
                )}
              </span>
            )}
          </div>
        )}

        {this.props.errorMsg && (
          <div className={s.error}>{this.props.errorMsg}</div>
        )}
        {(shouldShowAddCommentBox || this.props.openCommentBox) && (
          <CommentWriteBox
            showAddCommentBox={this.showAddCommentBox}
            toggleResponses={this.toggleResponses}
            userData={this.props.userData}
            openLoginBox={this.props.openLoginBox}
            isUserLoggedin={this.props.isUserLoggedin}
            handleAddComment={this.handleAddComment}
            pageMsid={this.props.pageMsid}
            getMsid={this.getMsid}
            getImmediateParent={this.getImmediateParent}
            getParentComment={this.getParentComment}
            renderUserIcon={this.props.renderUserIcon}
            disclaimer={this.props.disclaimer}
            showCloseButton
            styles={this.props.styles}
            prime={this.props.isPrime}
            isWapView={this.props.isWapView}
            commentTextInputRef={this.props.commentTextInputRef}
            showVerificationMsg={this.props.showVerificationMsg}
            seoData={this.props.seoData}
            isPrivateUser={this.props.isPrivateUser}
            toipLayout={this.props.toipLayout}
          />
        )}
        <div className={s.indentRight}>
          {(shouldShowResponses || !isParent) &&
            this.props.level < 1 &&
            this.props.renderCommentList(
              this.state.showAllReplies ? flatChild : flatChild.slice(0, 3),
              this,
              this.props.level + 1,
            )}
          {(shouldShowResponses || !isParent) &&
            this.props.level === 0 &&
            !this.state.showAllReplies &&
            flatChild.length > 3 && (
              <div
                className={s.show_all_responses}
                onClick={() => this.showAllResponses()}
              >
                Show all responses
              </div>
            )}
        </div>
      </li>
    );
  }
}

export default CommmentItem;
